import { faSearch, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';

const redirectionURL = process.env.REACT_APP_REDIRECTION_URL
const MobileSearchBox = ({ isSearchOpen, setIsSearchOpen }) => {
    const ref = useRef(null);
    const [searchValue, setSearchValue] = useState("");
    const [searchValueError, setSearchValueError] = useState(false)

    const handleInputChange = (event) => {
        if (event.target.value) {
            setSearchValueError(false)
        } else {
            setSearchValueError(true)
        }
        setSearchValue(event.target.value);
    };

    const handleSearchIconClick = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    const handleSearch = ()=> {
        if (searchValue) {
            window.location.assign(`${redirectionURL}?search=${searchValue}`)
        } else {
            setSearchValueError(true)
        }
    }


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsSearchOpen(false);
            }
        };

        if (isSearchOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isSearchOpen, setIsSearchOpen]);

    return (
        <div id="modalOverlay" className={`modal-overlay ${isSearchOpen ? "show-modal" : ""}`}>
            <div className="modal" ref={ref}>
                {/* <button className="modal-close" onClick={handleSearchIconClick}>
                    <FontAwesomeIcon icon={faXmark} />
                </button> */}
                <div className="search-box">
                    <input 
                        placeholder="Search Songs" 
                        value={searchValue}
                        onChange={handleInputChange} 
                    />
                    <button className="mobsearch_trigger" onClick={handleSearch}>
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    </button>
                </div>
                {searchValueError && <p className='error-search-msg'>Cannot Search blank Value</p> }
            </div>
        </div>
    );
};

export default MobileSearchBox;
